import React, { PropTypes, Component } from "react";
import styled from "styled-components";
import {
	NitroGrid,
	NitroLoading,
	NitroContentNotAvailable
} from "nitro-components";

import DashboardApi from "../../../api/DashboardApi";

import {
	ReportDonutView,
	ReportSemiDonutView,
	ReportDueMeter,
	ReportOdometer
} from "./reports";

import { transformDashboardData } from "../../insights/DataTransformer";

const Container = styled.div`

`;

const GridContainer = styled.div``;

const Loader = styled.div`
  position: relative;
  height: 120px;
`;

class ReportDetailedView extends Component {
	constructor(props) {
		super(props);
		this.state = {
			data: {},
			loading: false
		};
		this.loadData = this.loadData.bind(this);
	}

	componentWillMount() {
		const {
			reportId,
			countryCode,
			companyCode,
			driverId,
			leaseId,
			type
		} = this.props;
		this.loadData(
			reportId,
			countryCode,
			companyCode,
			driverId,
			leaseId,
			type
		);
	}

	shouldComponentUpdate(nextProps, nextState) {
		if (nextState.data === this.state.data) {
			return false;
		}

		return true;
	}

	componentWillReceiveProps(nextProps) {
		if (nextProps.leaseId && nextProps.leaseId !== this.props.leaseId) {
			this.loadData(
				nextProps.reportId,
				nextProps.countryCode,
				nextProps.companyCode,
				nextProps.driverId,
				nextProps.leaseId,
				nextProps.type
			);
		}
	}

	generatePanel = () => {};

	fetchReportDetail = params => {
		params.id = this.props.reportId;
		params.companyCode = this.props.companyCode;
		params.countryCode = this.props.countryCode;
		params.driverId = this.props.driverId;
		params.leaseId = this.props.leaseId;
		this.props.fetchReportDetail(params);
	};

	loadData = (id, countryCode, companyCode, driverId, leaseId, type) => {
		this.setState({
			loading: true
		});

		DashboardApi.getReportData({
			id,
			countryCode,
			companyCode,
			driverId,
			leaseId,
			type
		})
			.then(data => {
				if (data.data.Data) {
					this.setState({
						data: transformDashboardData(data.data),
						loading: false,
						reportType: data.data.DisplayType
					});
					console.log(this);
				} else {
					this.setState({
						data: null,
						loading: false,
						reportType: data.data.DisplayType
					});
					console.log("DashboardApi.getTileData error");
				}
			})
			.catch(error => {
				console.log("DashboardApi.getTileData error", error);
			});
	};

	render() {
		const { reportUrl, reportId, type } = this.props;
		const { reportType } = this.state;
		let displayReportComponent = false;
		let ReportComponent;
		switch (reportType) {
			case "cardDonut":
				displayReportComponent =
					this.state.data.length > 0 && !this.state.loading;
				ReportComponent = ReportDonutView;
				break;
			case "cardSemiDonut":
				displayReportComponent =
					this.state.data.length > 0 && !this.state.loading;
				ReportComponent = ReportSemiDonutView;
				break;
			case "due-meter":
				displayReportComponent =
					 !this.state.loading;
				ReportComponent = ReportDueMeter;
				break;
			case "odometer":
				ReportComponent = ReportOdometer;
				displayReportComponent = this.state.data && !this.state.loading;
				break;
			default:
				ReportComponent = ReportDonutView;
				displayReportComponent = this.state.data && !this.state.loading;
				break;
		}
		if (this.state.loading) {
			return <NitroLoading center />;
		}

		return (
			<NitroGrid grid={1} noPadding>
				<Container>
					{/*this.state.data.length > 0 && */
					displayReportComponent &&
						<ReportComponent
							{...this.state}

							fetchReportDetail={this.fetchReportDetail}
						/>}
					{!displayReportComponent && <NitroContentNotAvailable />}

				</Container>
			</NitroGrid>
		);
	}
}

ReportDetailedView.propTypes = {
	reportUrl: PropTypes.string,
	reportId: PropTypes.string,
	fetchReportDetail: PropTypes.func,
	companyCode: PropTypes.string,
	countryCode: PropTypes.string,
	driverId: PropTypes.string,
	leaseId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	type: PropTypes.string
};

ReportDetailedView.defaultProps = {
	// defaultProp: ''
};

export default ReportDetailedView;



// WEBPACK FOOTER //
// ./src/features/dashboard/components/ReportDetailedView.js